import { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useColors } from '../context/ThemeContext';

export default function PasswordField({ InputProps: inputPropsProp, ...props }) {
  const [show, setShow] = useState(false);
  const colors = useColors();
  return (
    <TextField
      {...props}
      type={show ? 'text' : 'password'}
      InputProps={{
        ...inputPropsProp,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton size="small" onClick={() => setShow(s => !s)} edge="end"
              aria-label={show ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
              sx={{ color: colors.textSecondary }}>
              {show ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
